export default __webpack_public_path__ + "media/images/check-5d8993cb618d1e032a1ff0008c3130b8.svg";